import { c as _c } from "react/compiler-runtime";
import { LOCALE } from '@/constants/config';
import useActivityBookingHandlers from '@/contexts/activityBookingContext/hooks/useActivityBookingHandlers';
import usePageExperienceId from '@/contexts/pageContext/hooks/usePageExperienceId';
import usePageTunnelBookingType from '@/contexts/pageContext/hooks/usePageTunnelBookingType';
import usePageTunnelStep from '@/contexts/pageContext/hooks/usePageTunnelStep';
import useQuery from '@/hooks/useQuery';
import { TunnelBookableQuery } from '@/queries/bookables.gql';
import { FPagePreciseNameEnum } from '@/types/pages';
import { FTunnelPageBookingTypeEnum, FTunnelPageStepEnum } from '@/types/tunnel';
import sendGTMPageView from '@/utils/gtm/sendGTMPageView';
import { Error, LoaderWithContainer } from '@winelidays/wld-tsx-2/elements';
import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import useInternalTunnelBookingFilters from './internalHooks/useInternalTunnelBookingFilters';
import TunnelContext from './tunnel.context';
export const TunnelProvider = (t0) => {
    const $ = _c(38);
    const { children } = t0;
    const location = useLocation();
    const pageTunnelStep = usePageTunnelStep();
    const tunnelStep = pageTunnelStep ?? FTunnelPageStepEnum.booking;
    const pageBookingType = usePageTunnelBookingType();
    const bookingType = pageBookingType ?? FTunnelPageBookingTypeEnum.standard;
    const tunnelBookingFilters = useInternalTunnelBookingFilters(bookingType);
    const experienceId = usePageExperienceId();
    let t1;
    if ($[0] !== bookingType || $[1] !== experienceId || $[2] !== location.pathname || $[3] !== tunnelStep) {
        t1 = () => {
            let pageName;
            bb10: switch (tunnelStep) {
                case FTunnelPageStepEnum.validation: {
                    if (bookingType === FTunnelPageBookingTypeEnum.voucher) {
                        pageName = FPagePreciseNameEnum.voucherValidation;
                    }
                    else {
                        pageName = FPagePreciseNameEnum.bookingValidation;
                    }
                    break bb10;
                }
                case FTunnelPageStepEnum.confirmation: {
                    if (bookingType === FTunnelPageBookingTypeEnum.voucher) {
                        pageName = FPagePreciseNameEnum.voucherConfirmation;
                    }
                    else {
                        pageName = FPagePreciseNameEnum.bookingConfirmation;
                    }
                    break bb10;
                }
                case FTunnelPageStepEnum.booking: { }
                default: {
                    if (bookingType === FTunnelPageBookingTypeEnum.voucher) {
                        pageName = FPagePreciseNameEnum.voucherTunnel;
                    }
                    else {
                        pageName = FPagePreciseNameEnum.bookingTunnel;
                    }
                }
            }
            sendGTMPageView({ custom_page_path: location.pathname, page_name: pageName, experience_id: experienceId });
        };
        $[0] = bookingType;
        $[1] = experienceId;
        $[2] = location.pathname;
        $[3] = tunnelStep;
        $[4] = t1;
    }
    else {
        t1 = $[4];
    }
    let t2;
    if ($[5] !== bookingType || $[6] !== experienceId || $[7] !== location || $[8] !== tunnelStep) {
        t2 = [tunnelStep, bookingType, experienceId, location];
        $[5] = bookingType;
        $[6] = experienceId;
        $[7] = location;
        $[8] = tunnelStep;
        $[9] = t2;
    }
    else {
        t2 = $[9];
    }
    useEffect(t1, t2);
    const isBookingStep = tunnelStep === FTunnelPageStepEnum.booking;
    const isValidationStep = tunnelStep === FTunnelPageStepEnum.validation;
    const t3 = !experienceId;
    let t4;
    if ($[10] !== experienceId) {
        t4 = { cheap: false, id: experienceId, locale: LOCALE };
        $[10] = experienceId;
        $[11] = t4;
    }
    else {
        t4 = $[11];
    }
    let t5;
    if ($[12] !== t3 || $[13] !== t4) {
        t5 = { fetchPolicy: "cache-and-network", skip: t3, variables: t4 };
        $[12] = t3;
        $[13] = t4;
        $[14] = t5;
    }
    else {
        t5 = $[14];
    }
    const { data, loading: loadingExperience, error: errorLoadingExperience } = useQuery(TunnelBookableQuery, t5);
    const experience = data?.bookable ?? null;
    const { handleStopQueries: handleStopActivityQueries } = useActivityBookingHandlers();
    const isBookingStepRef = useRef(isBookingStep);
    let t6;
    let t7;
    if ($[15] !== isBookingStep) {
        t6 = () => {
            isBookingStepRef.current = isBookingStep;
        };
        t7 = [isBookingStep];
        $[15] = isBookingStep;
        $[16] = t6;
        $[17] = t7;
    }
    else {
        t6 = $[16];
        t7 = $[17];
    }
    useEffect(t6, t7);
    let t8;
    let t9;
    if ($[18] !== handleStopActivityQueries || $[19] !== isBookingStep) {
        t8 = () => () => {
            if (isBookingStep && !isBookingStepRef.current) {
                handleStopActivityQueries();
            }
        };
        t9 = [isBookingStep, handleStopActivityQueries];
        $[18] = handleStopActivityQueries;
        $[19] = isBookingStep;
        $[20] = t8;
        $[21] = t9;
    }
    else {
        t8 = $[20];
        t9 = $[21];
    }
    useEffect(t8, t9);
    let t10;
    if ($[22] !== bookingType || $[23] !== experience || $[24] !== experienceId || $[25] !== isBookingStep || $[26] !== isValidationStep || $[27] !== tunnelBookingFilters || $[28] !== tunnelStep) {
        t10 = { tunnelStep, experienceId, experience, isBookingStep, isValidationStep, bookingType, tunnelBookingFilters };
        $[22] = bookingType;
        $[23] = experience;
        $[24] = experienceId;
        $[25] = isBookingStep;
        $[26] = isValidationStep;
        $[27] = tunnelBookingFilters;
        $[28] = tunnelStep;
        $[29] = t10;
    }
    else {
        t10 = $[29];
    }
    const contextValue = t10;
    let t11;
    if ($[30] !== children || $[31] !== errorLoadingExperience || $[32] !== experienceId || $[33] !== loadingExperience) {
        t11 = !experienceId ?
            <Error>Failed to parse experienceId</Error> :
            errorLoadingExperience ?
                <Error>Failed to fetch experience</Error> :
                loadingExperience ?
                    <LoaderWithContainer className="h-72"/> :
                    children;
        $[30] = children;
        $[31] = errorLoadingExperience;
        $[32] = experienceId;
        $[33] = loadingExperience;
        $[34] = t11;
    }
    else {
        t11 = $[34];
    }
    let t12;
    if ($[35] !== contextValue || $[36] !== t11) {
        t12 = <TunnelContext value={contextValue}>{t11}
    </TunnelContext>;
        $[35] = contextValue;
        $[36] = t11;
        $[37] = t12;
    }
    else {
        t12 = $[37];
    }
    return t12;
};
